// @ts-expect-error no types
import { fetchQuotes } from './fetchQuotes';
import { PromiseClient } from 'hub-http/adapters/promiseClient';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';

export const quotesApiWrapper = (
  httpClient: PromiseClient,
  contactVid: string
) => ({
  fetchRenderedContent({ id }: { id: string }) {
    return fetchQuotes({
      httpClient,
      objectType: CONTACT,
      objectId: contactVid,
    }).then((results: any) => {
      let quote: any;
      const hasId = results.some((el: any) => {
        const found = el.options.find((q: any) => q.value === id);
        if (found) quote = found;
        return !!found;
      });
      if (hasId && quote) {
        return {
          htmlBody: `<a href="${quote.value}">${quote.title}</a>`,
        };
      }
      return { htmlBody: '' };
    });
  },
  searchArticles({
    query,
    count,
  }: {
    query: string | undefined;
    count: number | undefined;
  }) {
    return fetchQuotes({
      httpClient,
      objectType: CONTACT,
      objectId: contactVid,
    }).then((results: any) => {
      const queryResults = results.filter(
        (res: any) => res.text && res.text.includes(query)
      );
      return count ? queryResults.slice(0, count) : queryResults;
    });
  },
});
